import _defineProperty from "@babel/runtime/helpers/defineProperty";
/*
 *                     NOTICE
 *            COPYRIGHT 2023 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */
import { AbPopup } from "abreact/incubator/ui/popup/AbPopup";
import { PopupPosition } from "abreact/incubator/ui/popup/PopupPosition";
import { PopupUtils } from "abreact/incubator/ui/popup/PopupUtils";
import { CssUtils } from "abreact/incubator/ui/utils/CssUtils";
import * as React from "react";
export class DragOverValidationErrorTooltip extends React.Component {
  constructor(props) {
    super(props);
    this.onClose = this.onClose.bind(this);
  }
  render() {
    const classNames = ["ab-tooltip", "ab-gee-operand-drag-over-validation-error-tooltip"];
    const positioner = PopupUtils.createVerticalPositioner({
      spacing: DragOverValidationErrorTooltip.VERTICAL_SPACING
    });
    return /*#__PURE__*/React.createElement(AbPopup, {
      className: CssUtils.composeClassNames(...classNames),
      onClose: this.onClose,
      modal: false,
      positioner: positioner,
      position: PopupPosition.ABOVE,
      origin: this.props.origin ?? undefined,
      resizable: false,
      draggable: false,
      flushContent: true,
      stayInInitialPosition: true
    }, /*#__PURE__*/React.createElement("div", {
      className: "ab-tooltip-content"
    }, this.props.children));
  }

  /*
   * This is a fully controlled component, with its construction and cleanup controlled exclusively by its parent.
   */
  onClose() {}
}
_defineProperty(DragOverValidationErrorTooltip, "VERTICAL_SPACING", 4);
//# sourceMappingURL=DragOverValidationErrorTooltip.js.map
